import { useTranslation } from "react-i18next";
import vconst from "utils/helpers/structs/vconst";

const OperStatBadge = ({operStatus, fs=12}) => {
    const { t } = useTranslation(['Warehouses']);
    return (
        <span className={`badge ${vconst.bgRowOperStat?.[operStatus]||'bg-light-success'} d-block d-md-inline mb-1 fs-${fs}`}>
        {t(`operStatus.${operStatus}`)}
        </span>)
} 

export default OperStatBadge;